module.exports = __webpack_public_path__ + "img/vicon3.85f080de.png";